<div class="bmc-fr-connector-container">
  <biz-fr-config-list
    [connectors]="frConfigurations"
    [selectedConnector]="selectedConfig"
    [isLoading]="isLoading"
    (onSelectConnector)="applySelectConnector($event)">
  </biz-fr-config-list>

  <biz-fr-config-detail *ngIf="selectedConfig" (cancelAction)="cancelAction()"
                         [frConfig]="selectedConfig"></biz-fr-config-detail>
  <div class="bmc-fr-connector-container__empty"
       *ngIf="frConfigurations && frConfigurations.length > 0&& !selectedConfig">
    <h3>{{'EXCEL_CONNECTOR.SELECT_A_CONNECTOR' | translate}}</h3>
  </div>

  <div class="bmc-fr-connector-container__empty" *ngIf="!frConfigurations && !selectedConfig">
    <h3>{{'EXCEL_CONNECTOR.EMPTY' | translate}}</h3>
  </div>
</div>
